import { render, staticRenderFns } from "./DeviceAuthorization.vue?vue&type=template&id=66ac8dba&scoped=true&"
import script from "./DeviceAuthorization.vue?vue&type=script&lang=js&"
export * from "./DeviceAuthorization.vue?vue&type=script&lang=js&"
import style0 from "./DeviceAuthorization.vue?vue&type=style&index=0&id=66ac8dba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ac8dba",
  null
  
)

export default component.exports